<template>
  <div class="Swiper-father">
    <div class="swiper-container" :class="containerClass.slice(1)">
      <div class="swiper-wrapper">
        <div class="swiper-slide" v-for="item in imgList" :key="item.id">
          <img :src="item.imgUrl" alt="" />
          <div class="des" v-if="item.title">
            <p class="title">{{ item.title }}</p>
            <!-- <div class="button" v-if="item.path" @click="toNewPage(item.path)">
              learn more
            </div> -->
          </div>
        </div>
      </div>
    </div>
    <div class="swiper-pagination" :class="paginationClass.slice(1)"></div>
  </div>
</template>

<script>
import Swiper from "swiper";
export default {
  props: {
    swiperID: {
      type: String,
      default: "",
    },
    imgList: {
      type: Array,
      default: () => [],
    },
    isDesign: {
      type: Boolean,
      default: false,
    },
  },
  mounted() {
    this.$nextTick(() => {
      let mySwiper = new Swiper(this.containerClass, {
        lazyLoading: true, //启动延迟加载
        lazyLoadingInPrevNext: true, //延迟加载应用到最接近的slide的图片
        lazyLoadingInPrevNextAmount: 1, //加载下一个slide
        lazyLoadingOnTransitionStart: true, //过渡到slide一开始就加载，设置为true
        loop: true,
        autoplay: {
          disableOnInteraction: false,
        },
        pagination: {
          el: this.paginationClass,
          bulletClass: "my-bullet",
          clickable: true,
          bulletActiveClass: "my-bullet-active",
        },
        observer: true, //修改swiper自己或子元素时，自动初始化swiper
        observeParents: true, //修改swiper的父元素时，自动初始化swiper
        onSlideChangeEnd: function (swiper) {
          swiper.update();
          mySwiper.startAutoplay();
          mySwiper.reLoop();
        },
      });
      mySwiper.el.onmouseover = function () {
        mySwiper.autoplay.stop();
      };
      mySwiper.el.onmouseout = function () {
        mySwiper.autoplay.start();
      };
    });
  },
  computed: {
    containerClass() {
      return ".swiper-container" + this.swiperID;
    },
    paginationClass() {
      return ".swiper-pagination" + this.swiperID;
    },
  },
  data() {
    return {};
  },
  methods: {
    toNewPage(obj) {
      this.$router.push({ path: obj.path, query: obj.query });
    },
  },
};
</script>

<style lang="less" scoped>
.Swiper-father {
  .swiper-container {
    width: 100%;
    height: 100%;
    margin-left: 0;
    margin-bottom: 0.3rem;
    .swiper-wrapper {
      .swiper-slide {
        img {
          width: 100%;
          height: 100%;
        }
        .des {
          position: absolute;
          display: none;
          top: 0;
          left: 0;
          width: 100%;
          height: 100%;
          color: rgb(255, 255, 255);
          background-color: rgba(26, 23, 23, 0.5);
          justify-content: flex-end;
          align-items: flex-start;
          flex-direction: column;
          .title {
            padding: 10px;
            font-weight: 700;
            color: #ffffff;
          }
          .button {
            margin-top: 0.5rem;
            padding: 0.1rem;
            box-sizing: border-box;
            border: 0.05rem solid white;
            transition: all 0.5s ease-in-out;
            &:hover {
              cursor: pointer;
              color: #000000;
            }
          }
        }
        &:hover {
          .des {
            display: flex;
          }
        }
      }
    }
  }
  .degigSwiper {
    height: 5rem;
  }
  .swiper-pagination {
    position: static;
    display: flex;
    box-sizing: border-box;
    justify-content: center;
    align-items: center;
  }
}
/deep/ .my-bullet {
  display: inline-block;
  background: #000000;
  opacity: 1;
  width: 0.1rem;
  height: 0.1rem;
  margin-left: 0.35rem;
  border-radius: 50%;
  &:hover {
    cursor: pointer;
  }
}
/deep/ .my-bullet-active {
  background: #b94060;
  width: 0.15rem;
  height: 0.15rem;
}
@media screen and (max-width: 760px) {
  .Swiper-father {
    .swiper-container {
      .swiper-wrapper {
        .swiper-slide {
          .des {
            display: flex;
            background-color: rgba(185, 64, 96, 0);
            .button {
              padding: 0.1rem 0.3rem;
            }
          }
        }
      }
    }
  }
}
</style>
